import { InjectionToken } from '@angular/core';
import { KeyboardKeys } from 'ngx-keyboard-shortcuts';
export * from 'ngx-keyboard-shortcuts';

const defaultModuleConfig = {
    helpKeyBinding: [KeyboardKeys.Alt, KeyboardKeys.Shift, 'h'],
};
/**
 * Token used for providing the IKeyboardShortcutsModuleConfig
 * @example
 * // in the shared module's providers section
 * providers: [
 *      { provide: KeyboardShortcutsModuleConfigToken, useValue: keyboardShortcutsModuleConfig },
 * ]
 */
const KeyboardShortcutsModuleConfigToken = new InjectionToken('keyboard_shortcuts_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { KeyboardShortcutsModuleConfigToken, defaultModuleConfig };

//# sourceMappingURL=mt-ng2-keyboard-shortcuts-module-config.js.map